import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'app/backend/auth.service';
import { NTCRegisterComponent } from './ntc/ntc-register.component';
import { AuthComponent } from './root/auth/auth.component';
import { LogoutComponent } from './root/logout/logout.component';
import { RootComponent } from './root/root.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
    {
        path: '',
        component: RootComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'nederman',
                pathMatch: 'full'
            },
            {
                path: 'applications',
                loadChildren: () => import('./applications/applications.module').then(m => m.ApplicationsModule),
                data: {
                    roles: {
                        'HoldingAdmin': [
                            {
                                url: '/applications',
                                regex: '^\/applications.*'
                            }
                        ],
                    }
                }
            },
            {
                path: 'nederman',
                loadChildren: () => import('./nederman/nederman.module').then(m => m.NedermanModule),
                data: {
                    roles: {
                        'HoldingAdmin': [
                            {
                                url: '/nederman/companies',
                                regex: '^\/nederman\/companies.*'
                            },
                            {
                                url: '/nederman/users',
                                regex: '^\/nederman\/users.*'
                            }
                        ],
                        'NedermanAdmin': [
                            {
                                url: '/nederman/companies',
                                regex: '^\/nederman\/companies.*'
                            },
                            {
                                url: '/nederman/users',
                                regex: '^\/nederman\/users.*'
                            }
                        ]
                    }
                }
            },
            {
                path: 'customer',
                loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
                data: {
                    roles: {
                        'HoldingAdmin': [
                            {
                                url: '/customer/accounts',
                                regex: '^\/customer\/accounts.*'
                            },
                            {
                                url: '/customer/companies',
                                regex: '^\/customer\/companies.*'
                            },
                            {
                                url: '/customer/users',
                                regex: '^\/customer\/users.*'
                            }
                        ],
                        'NedermanAdmin': [
                            {
                                url: '/customer/accounts',
                                regex: '^\/customer\/accounts.*'
                            },
                            {
                                url: '/customer/companies',
                                regex: '^\/customer\/companies.*'
                            },
                            {
                                url: '/customer/users',
                                regex: '^\/customer\/users.*'
                            }
                        ],
                        'CustomerAdmin': [
                            {
                                url: '/customer/companies/{companyId}',
                                companyId: 'companyId',
                                regex: '^\/customer\/companies\/.+'
                            },
                            {
                                url: '/customer/users/',
                                regex: '^\/customer\/users\/.+'
                            }
                        ],
                        'CustomerUser': [
                            {
                                url: '/customer/companies/{companyId}',
                                companyId: 'companyId',
                                regex: '^\/customer\/companies\/.+'
                            }
                        ]
                    }
                }
            },
            {
                path: 'audit',
                loadChildren: () => import('./audit/audit.module').then(m => m.AuditModule),
                data: {
                    roles: {
                        'HoldingAdmin': [
                            {
                                url: '/audit/erp',
                                regex: '^\/audit\/erp$'
                            },
                            {
                                url: '/audit/action',
                                regex: '^\/audit\/action$'
                            }
                        ],
                        'NedermanAdmin': [
                            {
                                url: '/audit/action',
                                regex: '^\/audit\/action$'
                            }
                        ],
                        'CustomerAdmin': [
                            {
                                url: '/audit/action',
                                regex: '^\/audit\/action$'
                            }
                        ]
                    }
                }
            },
            {
                path: 'explorer',
                loadChildren: () => import('./explorer/explorer.module').then(m => m.ExplorerModule),
                data: {
                    roles: {
                        'HoldingAdmin': [
                            {
                                url: '/explorer',
                                regex: '^\/explorer$'
                            }
                        ],
                    }
                }
            },
            {
                path: 'playground',
                loadChildren: () => import('./explorer/explorer.module').then(m => m.ExplorerModule),
                data: {
                    roles: {
                        'HoldingAdmin': [
                            {
                                url: '/playgound',
                                regex: '^\/playground$'
                            }
                        ],
                    }
                }
            }
        ]
    },
    {
        path: 'ntcregister/:id',
        component: NTCRegisterComponent
    },
    {
        path: 'NTCregister/:id',
        component: NTCRegisterComponent
    },
    {
        path: 'auth',
        component: AuthComponent
    },
    {
        path: 'logout',
        component: LogoutComponent
    },
    {
        path: '**',
        redirectTo: ''
    }
], {})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
